import { defineStore } from "pinia";
import { usePage } from "@inertiajs/vue3";

const page = usePage();

export const useAuthStore = defineStore("auth", {
    state: () => ({
        can: page.props?.auth?.can || [],
    }),

    getters: {
        checkPermission: (state) => (permission) =>
            state.can.includes(permission),
        checkPermissionByStatus: (state) => (permission, statusId) => {
            if (!state.can.includes(permission)) {
                return false;
            }

            return state.can.includes(`${permission}.estado.${statusId}`);
        },
    },
    actions: {},
});
